export const setData = (state, data) => {
    state.data = data
}

export const setLoading = (state, loading) => {
    state.loading = loading
}

export const setError = (state, error) => {
    state.error = error
}

export const resetState = (state) => {
    state.data = {}
    state.loading = false
    state.error = null
    state.categories = []
    state.selectedCategory = null
    state.recordedTalks = []
    state.recordedTalksByCategory = {}
    state.favoriteRecordedTalks = []
    state.selectedRecordedTalk = null
    state.categoriesLoading = false
    state.talksLoading = false
    state.lastUpcomingTalk = null
    state.lastUpcomingTalkLoading = false
}

// Categories mutations
export const setCategories = (state, categories) => {
    state.categories = categories
}

export const setCategoriesLoading = (state, loading) => {
    state.categoriesLoading = loading
}

export const setSelectedCategory = (state, category) => {
    state.selectedCategory = category
}

// Recorded talks mutations
export const setRecordedTalks = (state, talks) => {
    state.recordedTalks = talks
}

export const setRecordedTalksByCategory = (state, { categoryId, talks }) => {
    state.recordedTalksByCategory = {
        ...state.recordedTalksByCategory,
        [categoryId]: talks
    }
}

export const setFavoriteRecordedTalks = (state, talks) => {
    state.favoriteRecordedTalks = talks
}

export const setSelectedRecordedTalk = (state, talk) => {
    state.selectedRecordedTalk = talk
}

export const setTalksLoading = (state, loading) => {
    state.talksLoading = loading
}

export const updateRecordedTalkFavorite = (state, { talkId, isFavorite }) => {
    // Update in recordedTalks array
    const talkIndex = state.recordedTalks.findIndex(talk => talk.id === talkId)
    if (talkIndex !== -1) {
        state.recordedTalks[talkIndex].isFavorite = isFavorite
    }

    // Update in recordedTalksByCategory
    Object.keys(state.recordedTalksByCategory).forEach(categoryId => {
        const talks = state.recordedTalksByCategory[categoryId]
        const categoryTalkIndex = talks.findIndex(talk => talk.id === talkId)
        if (categoryTalkIndex !== -1) {
            talks[categoryTalkIndex].isFavorite = isFavorite
        }
    })

    // Update selected talk if it's the same
    if (state.selectedRecordedTalk?.id === talkId) {
        state.selectedRecordedTalk.isFavorite = isFavorite
    }
}

// Last upcoming talk mutations
export const setLastUpcomingTalk = (state, talk) => {
    state.lastUpcomingTalk = talk
}

export const setLastUpcomingTalkLoading = (state, loading) => {
    state.lastUpcomingTalkLoading = loading
} 